export default __webpack_public_path__ + "static/media/brand3.3f439779.png";